import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasOrganisation from './aidas-organisation';
import AidasOrganisationDetail from './aidas-organisation-detail';
import AidasOrganisationUpdate from './aidas-organisation-update';
import AidasOrganisationDeleteDialog from './aidas-organisation-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasOrganisationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasOrganisationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasOrganisationDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasOrganisation} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasOrganisationDeleteDialog} />
  </>
);

export default Routes;
